import React, {useState} from 'react';
import './preview-info.sass';
import {PreviewDialogBox} from '../preview-dialog-box/preview-dialog-box';
import OnboardingMobile from '../../assets/preview/Onboarding_mobile.png';
import OnboardingSmall from '../../assets/preview/Onboarding_smm.png';
import OnboardingMdm from '../../assets/preview/Onboarding_mdm.png';
import Onboarding from '../../assets/preview/Onboarding_b.png';
import StartPage from '../../assets/preview/Start.png';
import StartMobile from '../../assets/preview/Start_mobile.png';
import StartSmall from '../../assets/preview/Start_smm.png';
import StartMdm from '../../assets/preview/Start_mdm.png';
import GoogleStore from '../../assets/preview/Google_play.png';
import AppleStore from '../../assets/preview/App_Store.png';
import VectorAnimation from '../../assets/preview/Vector_animation.png';
import VectorCircuit from '../../assets/preview/Vector_circuit.png';

export const PreviewInfo = () => {
    const [isImageBackLoaded, setIsImageBackLoaded] = useState(false);
    const [isImageFrontLoaded, setIsImageFrontLoaded] = useState(false);

    return (
        <div className='vv-preview-info-container'>
            <div className='vv-preview-info'>
                <div className='vv-preview-info__left'>
                    <PreviewDialogBox/>
                    <div className='vv-preview-info__text-container'>
                        <p>Miej wszystkie wydarzenia pod ręką, organizuj spontaniczne wypady ze znajomymi i zgarniaj zniżki do najlepszych miejscówek w Krakowie. Z nami nie ma nudy.</p>
                    </div>
                    <div className='vv-preview-info__left-store'>
                        <a href='https://play.google.com/store/apps/details?id=app.viceversa.mobile'>
                            <img className='vv-preview-info__store-image' src={GoogleStore} alt='Google store'/>
                        </a>
                        <a href='https://apps.apple.com/us/app/viceversa/id1605183101'>
                            <img className='vv-preview-info__store-image' src={AppleStore} alt='Apple store'/>
                        </a>
                    </div>
                </div>
                <div className='vv-preview-info__right'>
                    <div className='vv-preview-info__phone-container'>
                        <picture>
                            <source onLoad={() => setIsImageBackLoaded(true)} media='(min-width: 1250px)' srcSet={Onboarding}/>
                            <source onLoad={() => setIsImageBackLoaded(true)} media='(min-width: 920px)' srcSet={OnboardingMdm}/>
                            <source onLoad={() => setIsImageBackLoaded(true)} media='(min-width: 500px)' srcSet={OnboardingSmall}/>
                            <img onLoad={() => setIsImageBackLoaded(true)} className='vv-preview-info__phone-onboard-image' src={OnboardingMobile} alt='Viceversa onboard'/>
                        </picture>
                        <picture>
                            <source onLoad={() => setIsImageFrontLoaded(true)} media='(min-width: 1250px)' srcSet={StartPage}/>
                            <source onLoad={() => setIsImageFrontLoaded(true)} media='(min-width: 920px)' srcSet={StartMdm}/>
                            <source onLoad={() => setIsImageFrontLoaded(true)} media='(min-width: 500px)' srcSet={StartSmall}/>
                            <img onLoad={() => setIsImageFrontLoaded(true)} className='vv-preview-info__phone-start-image' src={StartMobile} alt='Viceversa start'/>
                        </picture>
                        <>
                            <img className='vv-preview-info__animation' src={VectorAnimation} alt='Viceversa arrow'/>
                            <img className='vv-preview-info__vector-circuit' src={VectorCircuit} alt='Viceversa circle'/>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};
